<template>
  <div class="back-top" @click="goTop" v-if="goTopShow">
    <span class="iconfont icon-to-top-line"></span>
    <span class="txt_tip">返回顶部</span>
  </div>
</template>

<script>
export default {
  name: 'backTop',
  props: {
    msg: String
  },
  data(){
    return{
      scrollTop: "",
      goTopShow:false
    }
  },
  watch:{
    scrollTop(val) {
      if (this.scrollTop > 500) {
          this.goTopShow = true;
      } else {
          this.goTopShow = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    goTop(){
      $('html, body').stop().animate({
          scrollTop: 0
      })
      // let timer = null,
      //     _that = this;
      // cancelAnimationFrame(timer);
      // timer = requestAnimationFrame(function fn() {
      //   if (_that.scrollTop > 0) {
      //       _that.scrollTop -= 70;
      //       document.body.scrollTop = document.documentElement.scrollTop =
      //           _that.scrollTop;
      //       timer = requestAnimationFrame(fn);
      //   } else {
      //       cancelAnimationFrame(timer);
      //       _that.goTopShow = false;
      //   }
      // });
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset ||  document.documentElement.scrollTop ||   document.body.scrollTop;
      if (this.scrollTop > 500) {
          this.goTopShow = true;
      }
    },
  },
}
</script>
<style scoped >
  

</style>